export var DropdownToggleMouseover = function ($document) {
    'ngInject';
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            elem.bind('mouseover', function () {
                elem.addClass('dropdown-active');
                elem.addClass('active-recent');
            });
            $document.bind('mouseover', function () {
                if (!elem.hasClass('active-recent')) {
                    elem.removeClass('dropdown-active');
                }
                elem.removeClass('active-recent');
            });
        }
    };
};
//# sourceMappingURL=dropdown-toggle-mouseover.js.map